import Header from "@/components/interface/Header"
import { ReactNode, useEffect } from "react"

type Props = {
  children: ReactNode
  showBackground?: boolean
}

const Layout = ({ children, showBackground = false }: Props) => {
  useEffect(() => {
    if (process.env.REACT_APP_BUGHERD_ID) {
      const script = document.createElement("script")
      script.src = `https://www.bugherd.com/sidebarv2.js?apikey=${process.env.REACT_APP_BUGHERD_ID}`
      script.async = true
      document.body.appendChild(script)

      return () => {
        document.body.removeChild(script)
      }
    }
  }, [])

  return (
    <div className="flex h-screen max-h-screen w-screen flex-col overflow-hidden">
      <Header showBackground={showBackground} />
      <main className="flex-1 overflow-y-auto">{children}</main>
    </div>
  )
}

export default Layout
